export default (email: string) =>
  fetch('https://mail-server.growheads.ru/api/subscribe', {
    method: 'POST',
    body: JSON.stringify({ email }),
  })
    .then(() => alert('Вы подписались на рассылку!'))
    .catch(() => alert('Что-то пошло не так :('))
